export default "__VITE_ASSET__MqrLFlRr__"